import { useIsUsCompany } from 'hooks/company/useCompanyRegion';
import { useIsUsCurrentTalent } from 'hooks/talents/useCurrentTalentRegion';

export const useCurrentAccountCountryQueryOptions = () => {
  const isUsCompany = useIsUsCompany();
  const isUsTalent = useIsUsCurrentTalent();
  const isUs = isUsCompany || isUsTalent;

  return isUs ? { is_us: true } : { is_europe: true };
};
